import { render, staticRenderFns } from "./OutlineButton.vue?vue&type=template&id=023b3828&scoped=true&"
import script from "./OutlineButton.vue?vue&type=script&lang=js&"
export * from "./OutlineButton.vue?vue&type=script&lang=js&"
import style0 from "./OutlineButton.vue?vue&type=style&index=0&id=023b3828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b3828",
  null
  
)

export default component.exports